"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerifiedBadge = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _designSystem = require("@storybook/design-system");

var _theming = require("@storybook/theming");

var _styles = require("./shared/styles");

var _excluded = ["trigger", "creator", "appearance"];
var VerifiedBadgeIcon = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Icon, process.env.NODE_ENV === "production" ? {
  target: "exw59zz1"
} : {
  target: "exw59zz1",
  label: "VerifiedBadgeIcon"
})("color:", function (props) {
  return props.appearance === 'official' ? _styles.color.secondary : _styles.color.green;
}, ";width:14px;height:14px;margin-bottom:2px;z-index:2;position:relative;");
var BadgeWrapper = ( /*#__PURE__*/0, _theming.styled)(_designSystem.WithTooltip, process.env.NODE_ENV === "production" ? {
  target: "exw59zz0"
} : {
  target: "exw59zz0",
  label: "BadgeWrapper"
})("margin-left:", _styles.spacing.padding.small, "px;");

var VerifiedBadge = function VerifiedBadge(_ref) {
  var _ref$trigger = _ref.trigger,
      trigger = _ref$trigger === void 0 ? 'hover' : _ref$trigger,
      _ref$creator = _ref.creator,
      creator = _ref$creator === void 0 ? '' : _ref$creator,
      appearance = _ref.appearance,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(BadgeWrapper, (0, _extends2["default"])({}, props, {
    placement: "top",
    trigger: trigger,
    tooltip: /*#__PURE__*/_react["default"].createElement(_designSystem.TooltipMessage, {
      desc: appearance === 'official' ? 'This addon is maintained and recommended by the Storybook team.' : "This addon is maintained by ".concat(creator, ".")
    })
  }), /*#__PURE__*/_react["default"].createElement(VerifiedBadgeIcon, {
    icon: "verified",
    appearance: appearance
  }));
};

exports.VerifiedBadge = VerifiedBadge;